'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateActiveBiddersSfs = exports.updateActiveBiddersPubnub = exports.nextLotLoaded = exports.nextLotOpened = exports.networkReconnected = exports.networkDisconnected = exports.missive = exports.lotUnsold = exports.lotSold = exports.lotSkipped = exports.lotReopened = exports.lotPassed = exports.lotClosed = exports.bidRetracted = exports.bidAccepted = exports.auctionStarted = exports.auctionClosed = exports.askChanged = exports.getLiveItemData = exports.getLiveCatalogData = exports.getPubNubPublishKey = exports.getCatalogBidders = exports.getCatalogMessages = exports.UPDATE_ACTIVE_BIDDERS_SFS = exports.UPDATE_ACTIVE_BIDDERS_PUBNUB = exports.NEXT_LOT_OPENED = exports.NEXT_LOT_LOADED = exports.NETWORK_RECONNECTED = exports.NETWORK_DISCONNECTED = exports.MISSIVE = exports.LOT_UNSOLD = exports.LOT_SOLD = exports.LOT_SKIPPED = exports.LOT_REOPENED = exports.LOT_PASSED = exports.LOT_CLOSED = exports.BID_RETRACTED = exports.BID_ACCEPTED = exports.AUCTION_STARTED = exports.AUCTION_ENDED = exports.ASK_CHANGED = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _user = require('./user');

var _liveBid = require('./liveBid');

var _catalogRegistration = require('./catalogRegistration');

var _catalog = require('./catalog');

var _liveCatalogStatus = require('./liveCatalogStatus');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var ASK_CHANGED = exports.ASK_CHANGED = 'ASK_CHANGED';
var AUCTION_ENDED = exports.AUCTION_ENDED = 'AUCTION_ENDED';
var AUCTION_STARTED = exports.AUCTION_STARTED = 'AUCTION_STARTED';
var BID_ACCEPTED = exports.BID_ACCEPTED = 'BID_ACCEPTED';
var BID_RETRACTED = exports.BID_RETRACTED = 'BID_RETRACTED';
var LOT_CLOSED = exports.LOT_CLOSED = 'LOT_CLOSED';
var LOT_PASSED = exports.LOT_PASSED = 'LOT_PASSED';
var LOT_REOPENED = exports.LOT_REOPENED = 'LOT_REOPENED';
var LOT_SKIPPED = exports.LOT_SKIPPED = 'LOT_SKIPPED';
var LOT_SOLD = exports.LOT_SOLD = 'LOT_SOLD';
var LOT_UNSOLD = exports.LOT_UNSOLD = 'LOT_UNSOLD';
var MISSIVE = exports.MISSIVE = 'MISSIVE';
var NETWORK_DISCONNECTED = exports.NETWORK_DISCONNECTED = 'NETWORK_DISCONNECTED';
var NETWORK_RECONNECTED = exports.NETWORK_RECONNECTED = 'NETWORK_RECONNECTED';
var NEXT_LOT_LOADED = exports.NEXT_LOT_LOADED = 'NEXT_LOT_LOADED';
var NEXT_LOT_OPENED = exports.NEXT_LOT_OPENED = 'NEXT_LOT_OPENED';
var UPDATE_ACTIVE_BIDDERS_PUBNUB = exports.UPDATE_ACTIVE_BIDDERS_PUBNUB = 'UPDATE_ACTIVE_BIDDERS_PUBNUB';
var UPDATE_ACTIVE_BIDDERS_SFS = exports.UPDATE_ACTIVE_BIDDERS_SFS = 'UPDATE_ACTIVE_BIDDERS_SFS';

/* helpers */
var addMessage = function addMessage(messages, catalogId, message) {
    var newMessages = (0, _cloneDeep2.default)(messages);
    newMessages[catalogId] = newMessages[catalogId] || [];
    newMessages[catalogId].push(message);
    newMessages[catalogId] = newMessages[catalogId].sort(function (a, b) {
        return a.created - b.created;
    });
    if (newMessages[catalogId].length > 500) {
        // reduce to 5 if we exceed 500 messages
        newMessages[catalogId] = newMessages[catalogId].slice(0, 5);
    }
    return newMessages;
};

var getCurrentTimestamp = function getCurrentTimestamp() {
    return new Date().getTime();
};

/* reducer */
var DEFAULT_STATE = {
    catalogs: {},
    items: {},
    messages: {}
};

var DEFAULT_CATALOG = {
    activeBidder: false,
    approved: false,
    bidderOutbid: false,
    bidders: 1,
    closed: true,
    currentItem: 0,
    networkStatus: 'connected',
    pubNubPublishKey: '',
    status: '',
    won: false
};

var setCatalogLive = function setCatalogLive(state, catalogId) {
    var catalogs = (0, _cloneDeep2.default)(state.catalogs);
    catalogs[catalogId] = catalogs[catalogId] || (0, _cloneDeep2.default)(DEFAULT_CATALOG);
    catalogs[catalogId].status = 'live';
    return catalogs;
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var catalogs = void 0;
    var itemId = void 0;
    var items = void 0;
    var messages = void 0;

    switch (action.type) {
        case ASK_CHANGED:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].currentItem = action.payload.itemId;
            items = (0, _cloneDeep2.default)(state.items);
            items[action.payload.itemId] = items[action.payload.itemId] || {};
            items[action.payload.itemId].currentAskPrice = action.payload.ask;

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                items: items
            });
        case AUCTION_ENDED:
            catalogs = (0, _cloneDeep2.default)(state.catalogs);
            catalogs[action.payload.catalogId] = catalogs[action.payload.catalogId] || {};
            catalogs[action.payload.catalogId].status = 'done';

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case AUCTION_STARTED:
            catalogs = setCatalogLive(state, action.payload.catalogId);

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case BID_ACCEPTED:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].currentItem = action.payload.itemId;
            catalogs[action.payload.catalogId].closed = false;
            catalogs[action.payload.catalogId].activeBidder = !!catalogs[action.payload.catalogId].activeBidder || !!action.payload.myBid;
            catalogs[action.payload.catalogId].bidderOutbid = !!action.payload.bidderOutbid;

            items = (0, _cloneDeep2.default)(state.items);
            items[action.payload.itemId] = items[action.payload.itemId] || { created: getCurrentTimestamp() };
            var current = items[action.payload.itemId];
            var currentCreatedTimeStamp = current.created;
            if (currentCreatedTimeStamp < action.payload.created) {
                current.created = action.payload.created;
                current.leadingBid = action.payload.amount;
                current.leadingBidder = action.payload.bidderId;
                current.currentAskPrice = action.payload.ask;
                current.source = action.payload.source;
            }

            messages = (0, _cloneDeep2.default)(state.messages);
            var type = action.payload.myBid ? 'mybid' : action.payload.bidderOutbid ? 'outbid' : action.payload.source !== 'Reserve' ? 'accepted' : '';

            var reserve = action.payload.source === 'Reserve';

            var data = {
                amount: action.payload.amount,
                bidderId: action.payload.bidderId,
                currency: action.payload.currency,
                paddleNumber: action.payload.paddleNumber,
                source: action.payload.source
            };

            switch (type) {
                case 'accepted':
                    messages = addMessage(messages, action.payload.catalogId, {
                        created: action.payload.created,
                        data: data,
                        type: type
                    });
                    break;
                case 'mybid':
                    messages = addMessage(messages, action.payload.catalogId, {
                        created: action.payload.created,
                        data: data,
                        type: type
                    });
                    break;
                case 'outbid':
                    messages = addMessage(messages, action.payload.catalogId, {
                        created: action.payload.created,
                        data: data,
                        type: type
                    });

                    messages = addMessage(messages, action.payload.catalogId, {
                        created: action.payload.created + 1,
                        data: data,
                        type: 'accepted'
                    });
                    break;
                default:
                    break;
            }

            if (reserve) {
                messages = addMessage(messages, action.payload.catalogId, {
                    created: action.payload.created + 1,
                    data: data,
                    type: 'reserve'
                });
            }

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                items: items,
                messages: messages
            });
        case BID_RETRACTED:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].currentItem = action.payload.itemId;
            catalogs[action.payload.catalogId].bidderOutbid = false;
            catalogs[action.payload.catalogId].closed = false;

            items = (0, _cloneDeep2.default)(state.items);
            items[action.payload.itemId] = items[action.payload.itemId] || {};
            items[action.payload.itemId].leadingBid = action.payload.amount;
            var myBid = items[action.payload.itemId].leadingBidder === action.payload.currentBidderId;
            items[action.payload.itemId].leadingBidder = action.payload.bidderId;
            items[action.payload.itemId].currentAskPrice = action.payload.ask;
            items[action.payload.itemId].source = action.payload.source;
            items[action.payload.itemId].created = action.payload.created;

            messages = addMessage(state.messages, action.payload.catalogId, {
                created: action.payload.created,
                data: {
                    amount: action.payload.ask,
                    currency: action.payload.currency,
                    myBid: myBid
                },
                type: 'retracted'
            });

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                items: items,
                messages: messages
            });
        case LOT_CLOSED:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].bidderOutbid = false;
            if (catalogs[action.payload.catalogId].currentItem === action.payload.itemId) {
                catalogs[action.payload.catalogId].closed = true;
            }

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case LOT_PASSED:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].closed = true;
            catalogs[action.payload.catalogId].bidderOutbid = false;

            messages = addMessage(state.messages, action.payload.catalogId, {
                created: action.payload.created,
                data: { lotNumber: action.payload.lotNumber },
                type: 'passed'
            });

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                messages: messages
            });
        case LOT_REOPENED:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].closed = false;

            messages = addMessage(state.messages, action.payload.catalogId, {
                created: action.payload.created,
                data: { lotNumber: action.payload.lotNumber },
                type: 'reopened'
            });

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                messages: messages
            });
        case LOT_SKIPPED:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].closed = true;
            catalogs[action.payload.catalogId].bidderOutbid = false;

            messages = addMessage(state.messages, action.payload.catalogId, {
                created: action.payload.created,
                data: { lotNumber: action.payload.lotNumber },
                type: 'skipped'
            });

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                messages: messages
            });
        case LOT_SOLD:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].closed = true;
            catalogs[action.payload.catalogId].bidderOutbid = false;
            catalogs[action.payload.catalogId].won = action.payload.myBid;
            messages = addMessage(state.messages, action.payload.catalogId, {
                created: action.payload.created,
                data: {
                    amount: action.payload.amount,
                    bidderId: action.payload.bidderId,
                    currency: action.payload.currency,
                    lotNumber: action.payload.lotNumber,
                    myBid: action.payload.myBid,
                    paddleNumber: action.payload.paddleNumber
                },
                type: 'sold'
            });

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                messages: messages
            });
        case LOT_UNSOLD:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].bidderOutbid = false;
            messages = addMessage(state.messages, action.payload.catalogId, {
                created: action.payload.created,
                data: { lotNumber: action.payload.lotNumber },
                type: 'unsold'
            });

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                messages: messages
            });
        case MISSIVE:
            catalogs = setCatalogLive(state, action.payload.catalogId);
            messages = addMessage(state.messages, action.payload.catalogId, {
                created: action.payload.created,
                text: action.payload.missiveText,
                type: 'missive'
            });

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                messages: messages
            });
        case NEXT_LOT_OPENED:
            // This does not do what one might think
            break;
        case NETWORK_DISCONNECTED:
            catalogs = (0, _cloneDeep2.default)(state.catalogs);
            catalogs[action.payload.catalogId] = catalogs[action.payload.catalogId] || {};
            catalogs[action.payload.catalogId].networkStatus = 'disconnected';
            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case NETWORK_RECONNECTED:
            catalogs = (0, _cloneDeep2.default)(state.catalogs);
            catalogs[action.payload.catalogId] = catalogs[action.payload.catalogId] || {};
            catalogs[action.payload.catalogId].networkStatus = 'connected';
            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case _catalogRegistration.LOAD_CATALOG_REGISTRATION_SUCCESS:
            catalogs = (0, _cloneDeep2.default)(state.catalogs);
            catalogs[action.meta.catalogId].pubNubPublishKey = action.payload.publishKey;
            var wasApproved = catalogs[action.meta.catalogId].approved;
            catalogs[action.meta.catalogId].approved = action.payload.approved;

            var newState = (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });

            if (!wasApproved && action.payload.approved) {
                messages = addMessage(state.messages, action.meta.catalogId, {
                    created: action.payload.created,
                    type: 'approved'
                });
                newState.messages = messages;
            }

            return newState;
        case _liveCatalogStatus.LOAD_LIVE_CATALOG_STATUS_SUCCESS:
            catalogs = (0, _cloneDeep2.default)(state.catalogs);
            catalogs[action.payload.catalogId] = catalogs[action.payload.catalogId] || {};
            catalogs[action.payload.catalogId].currency = action.payload.currency;
            catalogs[action.payload.catalogId].status = action.payload.status;
            catalogs[action.payload.catalogId].itemCount = action.payload.itemCount;

            items = (0, _cloneDeep2.default)(state.items);

            if (action.payload.currentItem.itemId) {
                var _action$payload$curre = action.payload.currentItem,
                    askPrice = _action$payload$curre.askPrice,
                    created = _action$payload$curre.created,
                    highEstimate = _action$payload$curre.highEstimate,
                    _itemId = _action$payload$curre.itemId,
                    leadingBid = _action$payload$curre.leadingBid,
                    leadingBidder = _action$payload$curre.leadingBidder,
                    lotDescription = _action$payload$curre.lotDescription,
                    lotNumber = _action$payload$curre.lotNumber,
                    lotTitle = _action$payload$curre.lotTitle,
                    lowEstimate = _action$payload$curre.lowEstimate;


                catalogs[action.payload.catalogId].closed = false;
                catalogs[action.payload.catalogId].won = false;
                catalogs[action.payload.catalogId].currentItem = _itemId;
                items[_itemId] = items[_itemId] || {};
                items[_itemId].created = created || getCurrentTimestamp();
                items[_itemId].currentAskPrice = askPrice;
                items[_itemId].description = lotDescription;
                items[_itemId].highEstimate = highEstimate;
                items[_itemId].leadingBid = leadingBid || 0;
                items[_itemId].leadingBidder = leadingBidder || 0;
                items[_itemId].lotNumber = lotNumber;
                items[_itemId].lowEstimate = lowEstimate;
                items[_itemId].title = lotTitle;
            }

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                items: items
            });
        case NEXT_LOT_LOADED:
            itemId = action.payload.itemId;

            catalogs = setCatalogLive(state, action.payload.catalogId);
            catalogs[action.payload.catalogId].currentItem = itemId;
            catalogs[action.payload.catalogId].currency = action.payload.currency;
            catalogs[action.payload.catalogId].closed = false;
            catalogs[action.payload.catalogId].won = false;
            catalogs[action.payload.catalogId].activeBidder = false;
            catalogs[action.payload.catalogId].bidderOutbid = false;

            items = (0, _cloneDeep2.default)(state.items);
            items[itemId] = items[itemId] || {};
            items[itemId].leadingBid = 0;
            items[itemId].leadingBidder = 0;
            items[itemId].currentAskPrice = action.payload.askPrice;
            items[itemId].lotNumber = action.payload.lotNumber;
            items[itemId].title = action.payload.lotTitle;
            items[itemId].description = action.payload.description;
            items[itemId].highEstimate = action.payload.highEstimate;
            items[itemId].lowEstimate = action.payload.lowEstimate;
            items[itemId].index = action.payload.index;
            items[itemId].status = action.payload.status;
            items[itemId].created = action.payload.created;

            messages = addMessage(state.messages, action.payload.catalogId, {
                created: action.payload.created,
                data: {
                    amount: action.payload.askPrice,
                    currency: action.payload.currency,
                    lotNumber: action.payload.lotNumber
                },
                type: 'opened'
            });

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs,
                items: items,
                messages: messages
            });
        case UPDATE_ACTIVE_BIDDERS_PUBNUB:
            catalogs = (0, _cloneDeep2.default)(state.catalogs);
            catalogs[action.payload.catalogId] = catalogs[action.payload.catalogId] || {};
            catalogs[action.payload.catalogId].pubnubBidderCount = action.payload.bidderCount;

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case UPDATE_ACTIVE_BIDDERS_SFS:
            catalogs = (0, _cloneDeep2.default)(state.catalogs);
            catalogs[action.payload.catalogId].currentItem = action.payload.itemId;

            catalogs[action.payload.catalogId] = catalogs[action.payload.catalogId] || {};
            catalogs[action.payload.catalogId].sfsBidderCount = action.payload.bidderCount;

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        case _catalog.LOAD_CATALOGS_SUCCESS:
            catalogs = (0, _cloneDeep2.default)(state.catalogs);
            action.payload.catalogs.forEach(function (catalog) {
                if (catalog.catalogStatus === 'done') {
                    // set the catalog to done if it is
                    catalogs[catalog.catalogId] = catalogs[catalog.catalogId] || {};
                    catalogs[catalog.catalogId].status = catalog.catalogStatus;
                }
            });

            return (0, _extends3.default)({}, state, {
                catalogs: catalogs
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.console;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var catalogsSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.catalogs;
});
var itemsSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.items;
});
var messagesSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.messages;
});

var getCatalogMessages = exports.getCatalogMessages = (0, _reselect.createSelector)([messagesSelector, idSelector], function (messages, id) {
    return (0, _cloneDeep2.default)(messages[id]) || [];
});

var getCatalogBidders = exports.getCatalogBidders = (0, _reselect.createSelector)([catalogsSelector, idSelector], function (catalogs, id) {
    var catalog = catalogs[id] || {};
    var sfs = catalog.sfsBidderCount || 0;
    var pubnub = catalog.pubnubBidderCount || 0;
    return sfs + pubnub || 1;
});

var getPubNubPublishKey = exports.getPubNubPublishKey = (0, _reselect.createSelector)([catalogsSelector, idSelector], function (catalogs, id) {
    var catalog = catalogs[id] || {};
    return catalog.pubNubPublishKey || '';
});

var getLiveCatalogData = exports.getLiveCatalogData = (0, _reselect.createSelector)([catalogsSelector, getCatalogBidders, idSelector], function (catalogs, bidders, id) {
    return (0, _cloneDeep2.default)((0, _extends3.default)({}, DEFAULT_CATALOG, catalogs[id] || {}, { bidders: bidders }));
});

var getLiveItemData = exports.getLiveItemData = (0, _reselect.createSelector)([itemsSelector, idSelector], function (items, id) {
    return (0, _cloneDeep2.default)(items[id]) || { leadingBid: 0, leadingBidder: 0 };
});

/* ACTION CREATORS */
var askChanged = exports.askChanged = function askChanged(_ref) {
    var ask = _ref.ask,
        catalogId = _ref.catalogId,
        created = _ref.created,
        currency = _ref.currency,
        itemId = _ref.itemId,
        lotNumber = _ref.lotNumber;
    return {
        payload: { ask: ask, catalogId: catalogId, created: created, currency: currency, itemId: itemId, lotNumber: lotNumber },
        type: ASK_CHANGED
    };
};

var auctionClosed = exports.auctionClosed = function auctionClosed(_ref2) {
    var catalogId = _ref2.catalogId,
        created = _ref2.created;
    return {
        payload: { catalogId: catalogId, created: created },
        type: AUCTION_ENDED
    };
};

var auctionStarted = exports.auctionStarted = function auctionStarted(_ref3) {
    var catalogId = _ref3.catalogId,
        created = _ref3.created;
    return {
        payload: { catalogId: catalogId, created: created },
        type: AUCTION_STARTED
    };
};

var bidAccepted = exports.bidAccepted = function bidAccepted(_ref4) {
    var amount = _ref4.amount,
        ask = _ref4.ask,
        bidderId = _ref4.bidderId,
        catalogId = _ref4.catalogId,
        created = _ref4.created,
        currency = _ref4.currency,
        itemId = _ref4.itemId,
        lotNumber = _ref4.lotNumber,
        myBid = _ref4.myBid,
        paddleNumber = _ref4.paddleNumber,
        source = _ref4.source;
    return function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, currentBidderId, _getUiLiveBid, bidderHasHighBid, submitted, bidderOutbid;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            state = getState();
                            currentBidderId = (0, _user.getBidderId)(state);
                            _getUiLiveBid = (0, _liveBid.getUiLiveBid)(state), bidderHasHighBid = _getUiLiveBid.bidderHasHighBid, submitted = _getUiLiveBid.submitted;
                            bidderOutbid = currentBidderId !== bidderId && bidderHasHighBid && bidderId !== -1 || submitted && !myBid;
                            return _context.abrupt('return', dispatch({
                                payload: {
                                    amount: amount,
                                    ask: ask,
                                    bidderId: bidderId,
                                    bidderOutbid: bidderOutbid,
                                    catalogId: catalogId,
                                    created: created,
                                    currency: currency,
                                    itemId: itemId,
                                    lotNumber: lotNumber,
                                    myBid: myBid,
                                    paddleNumber: paddleNumber,
                                    source: source
                                },
                                type: BID_ACCEPTED
                            }));

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function (_x3, _x4) {
            return _ref5.apply(this, arguments);
        };
    }();
};

var bidRetracted = exports.bidRetracted = function bidRetracted(_ref6) {
    var amount = _ref6.amount,
        ask = _ref6.ask,
        bidderId = _ref6.bidderId,
        catalogId = _ref6.catalogId,
        created = _ref6.created,
        currency = _ref6.currency,
        itemId = _ref6.itemId,
        lotNumber = _ref6.lotNumber,
        source = _ref6.source;
    return function () {
        var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch, getState) {
            var state, currentBidderId;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            state = getState();
                            currentBidderId = (0, _user.getBidderId)(state);
                            return _context2.abrupt('return', dispatch({
                                payload: { amount: amount, ask: ask, bidderId: bidderId, catalogId: catalogId, created: created, currency: currency, currentBidderId: currentBidderId, itemId: itemId, lotNumber: lotNumber, source: source },
                                type: BID_RETRACTED
                            }));

                        case 3:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined);
        }));

        return function (_x5, _x6) {
            return _ref7.apply(this, arguments);
        };
    }();
};

var lotClosed = exports.lotClosed = function lotClosed(_ref8) {
    var catalogId = _ref8.catalogId,
        created = _ref8.created,
        itemId = _ref8.itemId,
        lotNumber = _ref8.lotNumber;
    return {
        payload: { catalogId: catalogId, created: created, itemId: itemId, lotNumber: lotNumber },
        type: LOT_CLOSED
    };
};

var lotPassed = exports.lotPassed = function lotPassed(_ref9) {
    var catalogId = _ref9.catalogId,
        created = _ref9.created,
        lotNumber = _ref9.lotNumber;
    return {
        payload: { catalogId: catalogId, created: created, lotNumber: lotNumber },
        type: LOT_PASSED
    };
};

var lotReopened = exports.lotReopened = function lotReopened(_ref10) {
    var catalogId = _ref10.catalogId,
        created = _ref10.created,
        lotNumber = _ref10.lotNumber;
    return {
        payload: { catalogId: catalogId, created: created, lotNumber: lotNumber },
        type: LOT_REOPENED
    };
};

var lotSkipped = exports.lotSkipped = function lotSkipped(_ref11) {
    var catalogId = _ref11.catalogId,
        created = _ref11.created,
        lotNumber = _ref11.lotNumber;
    return {
        payload: { catalogId: catalogId, created: created, lotNumber: lotNumber },
        type: LOT_SKIPPED
    };
};

var lotSold = exports.lotSold = function lotSold(_ref12) {
    var amount = _ref12.amount,
        bidderId = _ref12.bidderId,
        catalogId = _ref12.catalogId,
        created = _ref12.created,
        currency = _ref12.currency,
        lotNumber = _ref12.lotNumber,
        myBid = _ref12.myBid,
        paddleNumber = _ref12.paddleNumber;
    return {
        payload: { amount: amount, bidderId: bidderId, catalogId: catalogId, created: created, currency: currency, lotNumber: lotNumber, myBid: myBid, paddleNumber: paddleNumber },
        type: LOT_SOLD
    };
};

var lotUnsold = exports.lotUnsold = function lotUnsold(_ref13) {
    var catalogId = _ref13.catalogId,
        created = _ref13.created,
        lotNumber = _ref13.lotNumber;
    return {
        payload: { catalogId: catalogId, created: created, lotNumber: lotNumber },
        type: LOT_UNSOLD
    };
};

var missive = exports.missive = function missive(_ref14) {
    var catalogId = _ref14.catalogId,
        created = _ref14.created,
        missiveText = _ref14.missiveText;
    return {
        payload: { catalogId: catalogId, created: created, missiveText: missiveText },
        type: MISSIVE
    };
};

var networkDisconnected = exports.networkDisconnected = function networkDisconnected(_ref15) {
    var catalogId = _ref15.catalogId;
    return { payload: { catalogId: catalogId }, type: NETWORK_DISCONNECTED };
};
var networkReconnected = exports.networkReconnected = function networkReconnected(_ref16) {
    var catalogId = _ref16.catalogId;
    return { payload: { catalogId: catalogId }, type: NETWORK_RECONNECTED };
};

var nextLotOpened = exports.nextLotOpened = function nextLotOpened(_ref17) {
    var amount = _ref17.amount,
        catalogId = _ref17.catalogId,
        created = _ref17.created,
        currency = _ref17.currency,
        itemId = _ref17.itemId;
    return {
        payload: { amount: amount, catalogId: catalogId, created: created, currency: currency, itemId: itemId },
        type: NEXT_LOT_OPENED
    };
};

var nextLotLoaded = exports.nextLotLoaded = function nextLotLoaded(_ref18) {
    var catalogId = _ref18.catalogId,
        created = _ref18.created,
        currency = _ref18.currency,
        itemId = _ref18.itemId,
        askPrice = _ref18.askPrice,
        highEstimate = _ref18.highEstimate,
        index = _ref18.index,
        description = _ref18.description,
        lotNumber = _ref18.lotNumber,
        lotTitle = _ref18.lotTitle,
        lowEstimate = _ref18.lowEstimate,
        status = _ref18.status;
    return {
        payload: {
            askPrice: askPrice,
            catalogId: catalogId,
            created: created,
            currency: currency,
            description: description,
            highEstimate: highEstimate,
            index: index,
            itemId: itemId,
            lotNumber: lotNumber,
            lotTitle: lotTitle,
            lowEstimate: lowEstimate,
            status: status
        },
        type: NEXT_LOT_LOADED
    };
};

var updateActiveBiddersPubnub = exports.updateActiveBiddersPubnub = function updateActiveBiddersPubnub(_ref19) {
    var bidderCount = _ref19.bidderCount,
        catalogId = _ref19.catalogId;
    return {
        payload: { bidderCount: bidderCount, catalogId: catalogId },
        type: UPDATE_ACTIVE_BIDDERS_PUBNUB
    };
};

var updateActiveBiddersSfs = exports.updateActiveBiddersSfs = function updateActiveBiddersSfs(_ref20) {
    var bidderCount = _ref20.bidderCount,
        catalogId = _ref20.catalogId,
        created = _ref20.created,
        itemId = _ref20.itemId;
    return {
        payload: { bidderCount: bidderCount, catalogId: catalogId, created: created, itemId: itemId },
        type: UPDATE_ACTIVE_BIDDERS_SFS
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/console.js
// module id = FSAu
// module chunks = 57